import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { LOCALES } from '../constants/paths';

import translationDA from './i18n/da/translation.json';
import translationEN from './i18n/en/translation.json';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Allow to set some ressources upon initialization and load others later
    partialBundledLanguages: true,
    // init with 'in-code' default translations
    resources: {
      da: {
        default: translationDA,
      },
      en: {
        default: translationEN,
      },
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    // have a common namespace used around the full app
    ns: ['translation'],
    defaultNS: 'translation',

    // If translation is not found, use default namespace
    fallbackNS: 'default',

    interpolation: {
      escapeValue: false,
    },
    // Use backend to load municipality-specific translations
    backend: {
      loadPath: LOCALES + '{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
